module.exports = function getResource(label, vars = []) {
    let resources = {
        quickTouchUp: 'We need a quick touch-up.',
        maintenance: 'The Beauty Board needs a little routine maintenance, but don’t worry-we’ll be back up in a snap. Meanwhile, try the search box to find what you need.',
        continueShopping: 'Continue Shopping'
    };

    return resources[label];
};
